import React, { Component } from "react";
import CartContext from "./CartContext";
import axios from "axios";
import { Table, Card, Row, Col, Alert } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement,
} from "chart.js";
import { Bar, Doughnut, Line } from "react-chartjs-2";

// Register Chart.js modules
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement
);

export default class RmInventoryDashboard extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      summary: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.loadSummary();
  }

  async loadSummary() {
    try {
      const { storeId } = this.context;
      const res = await axios.get(
        `${process.env.REACT_APP_API}RmInventoryDashboard/InventorySummary/${storeId}`
      );
      this.setState({ summary: res.data, loading: false });
    } catch (err) {
      console.error(err);
      this.setState({
        error: "Failed to load inventory summary",
        loading: false,
      });
    }
  }

  render() {
    const { summary, loading, error } = this.state;

    if (loading)
      return <Alert variant="info">Loading inventory dashboard...</Alert>;
    if (error) return <Alert variant="danger">{error}</Alert>;
    if (!summary || summary.message)
      return <Alert variant="warning">{summary?.message || "No data"}</Alert>;

    // Chart data
    const categoryLabels = summary.stockByCategory.map((c) => c.category);
    const categoryValues = summary.stockByCategory.map((c) => c.totalValue);

    const lowStockLabels = summary.lowStockItems.map((i) => i.name);
    const lowStockValues = summary.lowStockItems.map((i) => i.instock);

    const categoryChartData = {
      labels: categoryLabels,
      datasets: [
        {
          label: "Stock Value",
          data: categoryValues,
          backgroundColor: [
            "#0088FE",
            "#00C49F",
            "#FFBB28",
            "#FF8042",
            "#845EC2",
          ],
        },
      ],
    };

    const lowStockChartData = {
      labels: lowStockLabels,
      datasets: [
        {
          label: "In Stock Qty",
          data: lowStockValues,
          backgroundColor: "#FF4C4C",
        },
      ],
    };

    return (
      <div className="container mt-3 text-center">
        {/* <h3 className="py-3">
          📊 <b>Raw Materials Inventory Dashboard</b>
        </h3> */}

        {/* Summary Cards */}
        <Row className="mb-3">
          <Col md={4}>
            <Card className="p-3 shadow-sm text-center">
              <h5>Total Items</h5>
              <h3>{summary.totalItems}</h3>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="p-3 shadow-sm text-center">
              <h5>Total Stock Qty</h5>
              <h3>{summary.totalStockQty.toFixed(2)}</h3>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="p-3 shadow-sm text-center">
              <h5>Total Stock Value</h5>
              <h3>₹ {summary.totalStockValue.toFixed(0)}</h3>
            </Card>
          </Col>
        </Row>

        {/* Stock by Category */}
        <Row>
          <Col md={6}>
            <Card className="mb-3 shadow-sm">
              <Card.Header>Stock by Category (Table)</Card.Header>
              <Card.Body>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Total Qty</th>
                      <th>Total Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.stockByCategory.map((c, idx) => (
                      <tr key={idx}>
                        <td>{c.category}</td>
                        <td>{c.totalQty.toFixed(2)}</td>
                        <td>₹ {c.totalValue.toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="mb-3 shadow-sm">
              <Card.Header>Stock by Category (Doughnut Chart)</Card.Header>
              <Card.Body style={{ height: "300px" }}>
                <Doughnut data={categoryChartData} />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Low Stock Items */}
        <Row>
          <Col md={6}>
            <Card className="mb-3 shadow-sm">
              <Card.Header>Low Stock Items (Table)</Card.Header>
              <Card.Body>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>In Stock</th>
                      <th>Unit</th>
                      <th>Purchase Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.lowStockItems.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center">
                          ✅ No low stock items
                        </td>
                      </tr>
                    ) : (
                      summary.lowStockItems.map((i) => (
                        <tr key={i.id}>
                          <td>{i.name}</td>
                          <td>{i.instock}</td>
                          <td>{i.unit}</td>
                          <td>₹ {i.purchasePrice.toFixed(2)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="mb-3 shadow-sm">
              <Card.Header>Low Stock Items (Bar Chart)</Card.Header>
              <Card.Body style={{ height: "300px" }}>
                <Bar
                  data={lowStockChartData}
                  options={{
                    responsive: true,
                    plugins: { legend: { display: false } },
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
